import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Upload = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
            d= "M7.29289 36.7071C7.10536 36.5196 7 36.2652 7 36L7 31C7 30.4477 7.44772 30 8 30C8.55228 30 9 30.4477 9 31L9 35L31 35L31 31C31 30.4477 31.4477 30 32 30C32.5523 30 33 30.4477 33 31L33 36C33 36.5523 32.5523 37 32 37L8 37C7.73478 37 7.48043 36.8946 7.29289 36.7071ZM8.29289 15.7071C7.90237 15.3166 7.90237 14.6834 8.29289 14.2929L19.2929 3.29289C19.4804 3.10536 19.7348 3 20 3C20.2652 3 20.5196 3.10536 20.7071 3.29289L31.7071 14.2929C32.0976 14.6834 32.0976 15.3166 31.7071 15.7071C31.3166 16.0976 30.6834 16.0976 30.2929 15.7071L21 6.41421L21 31C21 31.5523 20.5523 32 20 32C19.4477 32 19 31.5523 19 31L19 6.41421L9.70711 15.7071C9.31658 16.0976 8.68342 16.0976 8.29289 15.7071Z"
            fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Upload;
